import DatePicker, { DatePickerProps } from '@mui/lab/DatePicker';
import { InputLabelProps, TextField } from '@mui/material';
import moment, { Moment } from 'moment';
import * as React from "react";
import { useTranslation } from 'react-i18next';

export const DatePickerMaxDate = new Date('2100-01-01');
export const DatePickerMinDate = new Date('1900-01-01');

export function DatePickerValidRange(dt: Date) {
    return (dt != null && (dt < DatePickerMinDate || dt > DatePickerMaxDate));
};

export type MuiKeyboardDatePickerProps = {
    error?: boolean;
    fullWidth?: boolean;
    placeholder?: string;
    InputLabelProps?: InputLabelProps;
    margin?: "none" | "normal" | "dense";
    variant?: "filled" | "outlined" | "standard";
    emptyLabel?: string;
    title?: string;
    onBlur?: () => void;
};

type Props = Omit<DatePickerProps<Moment>, "renderInput"> & MuiKeyboardDatePickerProps;

const MuiKeyboardDatePicker: React.FC<Props> = (props) => {
    const { t, i18n } = useTranslation();
    const {
        error: pError,
        fullWidth: pFullWidth,
        placeholder: pPlaceholder,
        InputLabelProps: pInputLabelProps,
        margin: pMargin,
        variant: pVariant,
        emptyLabel,
        title: pTitle,
        onBlur,
        ...rest } = props;

    var f = moment.localeData(i18n.language).longDateFormat('L');
    return (
        <DatePicker
            {...rest}
            inputFormat={f}
            aria-label={`${t("Components.MuiDatePicker.InputFormatMessage")}: ${f}`}
            okText={t("Components.MuiDatePicker.OkLabel")}
            cancelText={t("Components.MuiDatePicker.CancelLabel")}
            clearText={t("Components.MuiDatePicker.ClearLabel")}
            todayText={t("Components.MuiDatePicker.TodayLabel")}
            //    invalidLabel={t("Components.MuiDatePicker.InvalidLabel")}
            //    invalidDateMessage={t("Components.MuiDatePicker.InvalidDateMessage")}
            //    minDateMessage={t("Components.MuiDatePicker.MinDateMessage")}
            //    maxDateMessage={t("Components.MuiDatePicker.MaxDateMessage")}
            renderInput={
                (textFieldProps) => {
                    const { inputProps, InputProps, InputLabelProps, margin, variant, title, error, fullWidth, ...rest } = textFieldProps;
                    const placeholder = inputProps.value == null ? emptyLabel : pPlaceholder;
                    const { onBlur, ...inProps } = inputProps;
                    return (
                        <TextField
                            {...rest}
                            margin={pMargin || margin}
                            variant={pVariant || variant}
                            title={pTitle || title}
                            fullWidth={pFullWidth || fullWidth}
                            error={pError || error}
                            inputProps={
                                {
                                    ...inProps,
                                    placeholder: placeholder,
                                    onBlur: (e) => {
                                        if (onBlur) onBlur(e);
                                        if (props.onBlur) props.onBlur();
                                    }
                                }
                            }
                            InputProps={
                                {
                                    ...InputProps,
                                }
                            }
                            InputLabelProps={
                                {
                                    ...InputLabelProps,
                                    ...pInputLabelProps,
                                    shrink: (placeholder != null && placeholder.length > 0) || (inputProps.value != null && inputProps.value.length > 0)
                                }
                            }
                        />
                    );
                }
            }
        />
    );
};

export default MuiKeyboardDatePicker;
